export default "/images/vendor/flag-icon-css/flags/4x3/td.svg?230eddd3b5d97166b70e47afed43a67f";